import { createLookupTable } from '../utils';

const statuses = {
  closed: 'success',
  in_progress: 'info',
  in_review: 'inactive',
  postponed: 'warning',
  '': 'inactive',
} as const;

export type TaskStatusLabel = keyof typeof taskStatusTable;
export const taskStatusTable = createLookupTable(statuses, 'taskStatus');
